import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
import { Container, Row,  Col } from "react-bootstrap";
import "./HowCanWeHelp.scss";

// import ImgCardDesktop1 from "../../../images/home/selling-property-d.png";
// import ImgCardTablet1 from "../../../images/home/selling-property-d.png";
// import ImgCardMobile1 from "../../../images/home/selling-property-d.png";

// import ImgCardDesktop2 from "../../../images/home/buying-property-d.png";
// import ImgCardTablet2 from "../../../images/home/buying-property-d.png";
// import ImgCardMobile2 from "../../../images/home/buying-property-d.png";

// import ImgCardDesktop3 from "../../../images/home/renting-property-d.png";
// import ImgCardTablet3 from "../../../images/home/renting-property-d.png";
// import ImgCardMobile3 from "../../../images/home/renting-property-d.png";

// import ImgCardDesktop4 from "../../../images/home/letting-property-d.png";
// import ImgCardTablet4 from "../../../images/home/letting-property-d.png";
// import ImgCardMobile4 from "../../../images/home/letting-property-d.png";
import ReactMarkdown from "react-markdown"
import GetURL from '@Components/common/site/get-url';
import { getSrc } from "gatsby-plugin-image";
import Slider from "react-slick";
import { inViewOptions } from '../../../Components/utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const containerVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.4,
            ease: [0.33, 1, 0.68, 1],
            duration: 0.4
        }
    }
}

const items = {
    hidden: {
        opacity: 0,
        y: 40
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 0.3
        }
    }
}

const MotionColumn = motion(Col)

const HowCanWeHelp = (props) => {
    const settings = {
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots:true,
            },
          },
        ],
      }
    // const HowCanWeHelpList = [
    //     {
    //         ImgDesktop: ImgCardDesktop1,
    //         ImgTablet: ImgCardTablet1,
    //         ImgMobile: ImgCardMobile1,
    //         ImgCaptionText: "Selling Property",
    //     },
    //     {
    //         ImgDesktop: ImgCardDesktop2,
    //         ImgTablet: ImgCardTablet2,
    //         ImgMobile: ImgCardMobile2,
    //         ImgCaptionText: "Buying Property",
    //     },
    //     {
    //         ImgDesktop: ImgCardDesktop3,
    //         ImgTablet: ImgCardTablet3,
    //         ImgMobile: ImgCardMobile3,
    //         ImgCaptionText: "Renting Property",
    //     },
    //     {
    //         ImgDesktop: ImgCardDesktop4,
    //         ImgTablet: ImgCardTablet4,
    //         ImgMobile: ImgCardMobile4,
    //         ImgCaptionText: "Letting Property",
    //     },
    // ];


    return (
        <InView {...inViewOptions}>
            {({ ref, inView }) => {
                return (
                    <motion.section
                        ref={ref}
                        initial="hidden"
                        animate={inView ? "visible" : "hidden"}
                        variants={containerVariants}
                    >
                        <React.Fragment>
                            <section className={props.isMainPage ? 'how-can-we-help' : props.investments ? 'related-properties useful-links' : 'related-properties'}>
                                <Container>
                                    <ScrollAnimation animateIn='fadeInUp' animateOnce={true}>
                                        <Row>
                                            {props.isMainPage ?
                                                <Col lg={12}>
                                                    <div className="content-how-can-we-help">
                                                        <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                            <h2>{props.Title}<span className="stroke-text">{props.SubTitle}</span></h2>
                                                        </ScrollAnimation>
                                                        
                                                        <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                            <ReactMarkdown source={props.Content} allowDangerousHtml />
                                                        </ScrollAnimation>

                                                    </div>
                                                </Col> :
                                                <Col lg={12}>
                                                    {props.investments ? <h2>Useful Links</h2> : null}
                                                    <div className="sub-child-desc">
                                                        <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                            <ReactMarkdown source={props.Content} allowDangerousHtml />
                                                        </ScrollAnimation>
                                                    </div>
                                                </Col>
                                            }
                                        </Row>
                                        <div className="mobile-view-only">
                                        {/* <Row> */}
                                        <Slider {...settings}>
                                        {props.CTAS.map((item, index) => (
                                                <div className="card-container-box" variants={items}>
                                                    <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                        <div className="how-can-we-help-card">

                                                            {item.Image &&
                                                                <div className="card-img-box">
                                                                    <GetURL class="link-btn" label={item.CTA_1_label} alias={item.CTA_1_Url?.Alias} />
                                                                    {/* <picture>
                                                                        <source media="(min-width:992px)" srcSet={item.Image.url} />
                                                                        <source media="(min-width:768px)" srcSet={item.Image.url} />
                                                                        <img src={item.Image.url} alt={item.Image.alternativeText} />
                                                                    </picture> */}
                                                                    <img src={getSrc(item.Image?.url_sharp)} alt={item.Image?.alternativeText} />
                                                                </div>
                                                            }
                                                            <div className="img-card-title">
                                                                <ul>
                                                                    <li><GetURL label={item.CTA_1_label} alias={item.CTA_1_Url?.Alias} /></li>
                                                                </ul>
                                                            </div>
                                                            <div className="btm-border-card"></div>
                                                        </div>
                                                    </ScrollAnimation>
                                                </div>
                                            ))}
                                            </Slider>
                                            {/* </Row> */}
                                            </div>
                                        <div className="non-mobile-view-only">
                                            <Row>
                                            {props.CTAS.map((item, index) => (
                                                <MotionColumn md={6} xl={3} className="card-container-box margin-top-fix" variants={items}>
                                                    <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                        <div className="how-can-we-help-card">

                                                            {item.Image &&
                                                                <div className="card-img-box">
                                                                    <GetURL class="link-btn" label={item.CTA_1_label} alias={item.CTA_1_Url?.Alias} />
                                                                    {/* <picture>
                                                                        <source media="(min-width:992px)" srcSet={item.Image.url} />
                                                                        <source media="(min-width:768px)" srcSet={item.Image.url} />
                                                                        <img src={item.Image.url} alt={item.Image.alternativeText} />
                                                                    </picture> */}
                                                                    <img src={getSrc(item.Image?.url_sharp)} alt={item.Image?.alternativeText} />
                                                                </div>
                                                            }
                                                            <div className="img-card-title">
                                                                <ul>
                                                                    <li><GetURL label={item.CTA_1_label} alias={item.CTA_1_Url?.Alias} /></li>
                                                                </ul>
                                                            </div>
                                                            <div className="btm-border-card"></div>
                                                        </div>
                                                    </ScrollAnimation>
                                                </MotionColumn>
                                            ))}
                                            </Row>
                                            </div>
                                        
                                    </ScrollAnimation>
                                </Container>
                            </section>
                        </React.Fragment>
                    </motion.section>
                )
            }}
        </InView>
    )
}

export default HowCanWeHelp;